import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bottom?: string;
}

export const ToastPopup = styled.div<IProps>`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  ${mixin.flex({
    align: 'center',
  })}
  position: fixed;
  bottom: ${({ $bottom }) => $bottom}px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 335px;
  min-height: 44px;
  padding: 13px 15px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(10px);
  z-index: 1002;

  &.is-old-app-iphonex {
    bottom: 94px !important;
  }

  .text {
    position: relative;
    width: max-content;
    line-height: 130%;
    text-align: center;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    word-break: keep-all;
    z-index: 1002;
  }

  @media ${({ theme }) => theme.media.smMax} {
    bottom: ${({ $bottom }) => mixin.pxToVw($bottom || '60')};
    max-width: ${mixin.pxToVw('335')};
    min-height: ${mixin.pxToVw('44')};
    padding: ${mixin.pxToVw('13 15')};
    border-radius: ${mixin.pxToVw('6')};

    &.is-old-app-iphonex {
      bottom: ${mixin.pxToVw('94')} !important;
    }

    .text {
      font-size: ${mixin.pxToVw('14')};
    }
  }
`;
